export default __webpack_public_path__ + "d9e7d5fdfb91922b331bfa074bea94f5.png";